export const headerTyps = [
  { id: 'sales', name: '매출액' },
  { id: 'purchase', name: '매입액' },
  { id: 'profitPrice', name: '매출이익' },
  { id: 'profit', name: '이익률' },
];

export const prjHeaders = [
  { id: 'HM', name: '(H+M)', val: 'HM' },
  { id: 'L', name: '(L)', val: 'L' },
  //  { id: 'HML', name: '(H+M+L)', val: 'HML' },
  { id: 'F', name: '(F)', val: 'F' },
];

export const prjDeptHeaders = (strMonth, endMonth, target = '수주', target2) => {
  const headers = [
    { id: 'STAT', name: '연간 목표', val: 'STAT' },
    { id: 'OA', name: `${target} 실적 (A)\n (${strMonth} 월 ~ ${endMonth}월)`, val: 'OA' },
    { id: 'STATRATE', name: '목표 달성율', val: 'STATRATE' },
    { id: 'HM', name: `포캐스팅 (B=H+M)\n (01 월 ~ 12월)`, val: 'HM' },
    { id: 'ES', name: `${target2} 매출 예상실적 (A+B)`, val: 'ES' },
    { id: 'EXSTATRATE', name: '예상 목표 달성율', val: 'EXSTATRATE' },
  ];

  if (target === '매출') {
    return headers.filter(h => !['HM', 'ES', 'EXSTATRATE'].includes(h.id));
  }
  return headers;
};

export const prjDeptProfitHeaders = (strMonth, endMonth, target = '수주') => {
  const headers = [
    { id: 'STAT', name: '연간 목표', val: 'STAT' },
    { id: 'OA', name: `${target} 실적 (A)\n (${strMonth} 월 ~ ${endMonth}월)`, val: 'OA' },
    { id: 'SELLINGEX', name: '판관비\n실적', val: 'SELLINGEX' },
    { id: 'BUDGETAMT', name: '영업이익', val: 'BUDGETAMT' },
    { id: 'STATRATE', name: '목표 달성율', val: 'STATRATE' },
  ];
  return headers;
};

export const prjStatHeaderTyps = [
  { id: 'statSales', name: '매출액' },
  { id: 'statSalesEx', name: '매출이익' },
];

export const prjStatProfitHeaderTyps = [
  { id: 'statSales', name: '매출액' },
  { id: 'statSalesEx', name: '매출이익' },
  { id: 'statProfit', name: '영업이익' },
];

export const prjTargetRateHeaderTyps = [
  { id: 'targetRateSales', name: '매출액' },
  { id: 'targetRateProfit', name: '매출이익' },
];

export const prjTargetRateProfitHeaderTyps = [
  { id: 'targetRateSales', name: '매출액' },
  { id: 'targetRateProfit', name: '매출이익' },
  { id: 'budgetRateMargin', name: '영업이익' },
];

export const prjExTargetRateHeaderTyps = [
  { id: 'targetRateSales', name: '매출액' },
  { id: 'targetRateProfit', name: '매출이익' },
];

export const prjDeptHeaderTyps = [
  { id: 'forecastSales', name: '매출액 (f)' },
  { id: 'forecastProfitMargin', name: '매출이익 (g)' },
];

export const prjSalesHeaderTyps = [
  { id: 'forecastSales', name: '매출액 (a+f)' },
  { id: 'forecastProfitMargin', name: '매출이익 (e+g)' },
];

export const prjOrderHeaderTyps = [
  { id: 'sales', name: '매출액 (a)' },
  { id: 'salesProfitBefore', name: `정산 전\n매출 이익 (b)` },
  { id: 'collaborationBenefits', name: '협업이익 (c)' },
  { id: 'collaborationCost', name: '협업비용 (d)' },
  { id: 'finalSalesProfit', name: '최종 매출 이익\n(e=b+c-d)' },
  { id: 'salesProfitMargin', name: '매출\n이익률' },
];

export const prjRealSalesHeaderTyps = [
  { id: 'sales', name: '매출액 (a)' },
  { id: 'purchase', name: '매입액 (b)' },
  { id: 'salesProfitBefore', name: `정산 전\n매출 이익 (c=a-b)` },
  { id: 'collaborationBenefits', name: '협업이익 (d)' },
  { id: 'collaborationCost', name: '협업비용 (e)' },
  { id: 'finalSalesProfit', name: '최종 매출 이익\n(f=c+d-e)' },
  { id: 'salesProfitMargin', name: '매출\n이익률' },
];

export const prjRealSalesProfitHeaderTyps = [
  { id: 'sales', name: '매출액 (a)' },
  { id: 'purchase', name: '매입액 (b)' },
  { id: 'salesProfitBefore', name: `정산 전\n매출 이익 (c=a-b)` },
  { id: 'collaborationBenefits', name: '협업이익 (d)' },
  { id: 'collaborationCost', name: '협업비용 (e)' },
  { id: 'finalSalesProfit', name: '최종 매출 이익\n(f=c+d-e)' },
  { id: 'salesProfitMargin', name: '매출\n이익률' },
];

export const prjDeptCountHeaders = [
  { id: 'H', name: 'High', val: 'H' },
  { id: 'M', name: 'Middle', val: 'M' },
  { id: 'L', name: 'Low', val: 'L' },
];

export const smHeaderTyps = [
  { id: 'sales', name: '매출액' },
  { id: 'profitPrice', name: '매출이익' },
];
export const smHeaders = [
  { id: 'SG', name: '영업목표', val: 'SG' },
  { id: 'SP', name: '연 예상 매출 실적', val: 'SP' },
];

export const salesHeaderTyps1 = [
  { id: 'sales', name: '매출액' },
  { id: 'profitPrice', name: '매출이익' },
];
export const salesHeaderTyps2 = [
  { id: 'sales', name: '매출액' },
  { id: 'salesRate', name: '목표달성률' },
  { id: 'profitPrice', name: '매출이익' },
  { id: 'achiveRate', name: '목표달성률' },
];
export const salesHeaders = [
  { id: 'sg', name: '영업목표', val: 'sg' },
  { id: 'sp', name: '연 예상 매출 실적', val: 'sp' },
  { id: 'tax', name: '세금계산서 실적', val: 'tax' },
  { id: 'ord', name: '수주금액(세금계산서 미발행)', val: 'ord' },
  { id: 'chance', name: '포캐스팅(H/M 이상)', val: 'chance' },
];

export const hqData = [
  {
    id: '1',
    name: '인프라영업본부',
    rowSpan: 1,
  },
  {
    id: '2',
    name: '채널영업본부',
    rowSpan: 1,
  },
  {
    id: '3',
    name: 'NI영업본부',
    rowSpan: 1,
  },
  {
    id: 'total',
    name: '합계',
    rowSpan: 1,
  },
];

export const teamData = [
  {
    id: '1',
    name: '인프라영업본부',
    rowSpan: 5,
    children: [
      { id: '1-1', name: '고객영업1팀' },
      { id: '1-2', name: '고객영업2팀' },
      { id: '1-3', name: '고객영업3팀' },
      { id: '1-4', name: '고객영업4팀' },
      {
        id: 'subTotal',
        name: '소계',
      },
    ],
  },
  {
    id: '2',
    name: '채널영업본부',
    rowSpan: 2,
    children: [
      { id: '2-1', name: '채널영업팀' },
      {
        id: 'subTotal',
        name: '소계',
      },
    ],
  },
  {
    id: '3',
    name: 'NI영업본부',
    rowSpan: 2,
    children: [
      { id: '2-1', name: 'NI영업팀' },
      {
        id: 'subTotal',
        name: '소계',
      },
    ],
  },
  {
    id: 'total',
    name: '합계',
    rowSpan: 1,
    children: [{ id: 'total', name: '합계' }],
  },
];

export const teamEmpData = [
  {
    id: '1',
    name: '전략사업본부',
    rowSpan: 9,
    children: [
      {
        id: '1-1',
        name: '전략사업1팀',
        rowSpan: 3,
        children: [
          { id: '1-1-1', name: '김인종 부장' },
          { id: '1-1-2', name: '양진섭 차장' },
          {
            id: 'subTotal',
            name: '소계',
          },
        ],
      },
      {
        id: '1-2',
        name: '전략사업2팀',
        rowSpan: 4,
        children: [
          { id: '1-2-1', name: '최광수 이사' },
          { id: '1-2-2', name: '조행래 전무' },
          { id: '1-2-3', name: '박재욱 차장' },
          {
            id: 'subTotal',
            name: '소계',
          },
        ],
      },
      {
        id: '1-3',
        name: '전략사업3팀',
        rowSpan: 2,
        children: [
          { id: '1-3-1', name: '심혁 이사' },
          {
            id: 'subTotal',
            name: '소계',
          },
        ],
      },
    ],
  },
  {
    id: '2',
    name: 'SI사업본부',
    rowSpan: 2,
    children: [
      {
        id: '2-1',
        name: 'SI사업본부 본부총괄',
        rowSpan: 2,
        children: [
          { id: '2-1-1', name: '이창준 이사' },
          {
            id: 'subTotal',
            name: '소계',
          },
        ],
      },
    ],
  },

  {
    id: 'total',
    name: '합계',
    rowSpan: 1,
    children: [
      {
        id: 'total',
        name: '합계',
        rowSpan: 1,
        children: [{ id: 'total', name: '합계' }],
      },
    ],
  },
];

export const makeDataPrjHeadquarterStat = () => {
  hqData.map((hq) => {
    return prjDeptHeaders.map((imp) => {
      let priceData = {};

      // 수주
      if (imp.val === 'OA') {
        priceData.colProfit = `${Math.floor(Math.random() * 1000000000)}`;
        priceData.colPrice = `${Math.floor(Math.random() * 1000000000)}`;
      }

      // 포캐스팅
      if (imp.val === 'HM') {
        priceData.colProfit = `${Math.floor(Math.random() * 1000000000)}`;
        priceData.colPrice = `${Math.floor(Math.random() * 1000000000)}`;
      }

      // 예상
      if (imp.val === 'ES') {
        priceData.colProfit = `${Math.floor(Math.random() * 1000000000)}`;
        priceData.colPrice = `${Math.floor(Math.random() * 1000000000)}`;
      }

      hq[imp.val] = priceData;
    });
  });
  return Array.from(hqData);
};

export const makeDataPrjDeptStat = () => {
  teamData.map((hq) => {
    return hq.children.map((team) => {
      return prjDeptHeaders.map((imp) => {
        let priceData = {
          sales: `${Math.floor(Math.random() * 1000000000)}`,
          profitPrice: `${Math.floor(Math.random() * 1000000000)}`,
        };
        team[imp.val] = priceData;
      });
    });
  });
  return Array.from(teamData);
};

export const makeDataPrjEmpStat = () => {
  teamEmpData.map((hq) => {
    return hq.children.map((team) => {
      return team.children.map((emp) => {
        return prjDeptHeaders.map((imp) => {
          let priceData = {
            sales: `${Math.floor(Math.random() * 1000000000)}`,
            profitPrice: `${Math.floor(Math.random() * 1000000000)}`,
          };
          emp[imp.val] = priceData;
        });
      });
    });
  });
  return Array.from(teamEmpData);
};

export const makeDataPrjDeptCount = () => {
  teamData.map((hq) => {
    return hq.children.map((team) => {
      return prjDeptCountHeaders.map((imp) => {
        team[imp.val] = `${Math.floor(Math.random() * 100)}`;
      });
    });
  });
  return Array.from(teamData);
};

export const makeDataSMStat = () => {
  teamEmpData.map((hq) => {
    return hq.children.map((team) => {
      return team?.children?.map((emp) => {
        return smHeaders.map((imp) => {
          let priceData = {
            sales: `${Math.floor(Math.random() * 1000000000)}`,
            profitPrice: `${Math.floor(Math.random() * 1000000000)}`,
          };
          emp[imp.val] = priceData;
        });
      });
    });
  });
  return Array.from(teamEmpData);
};

export const makeHqSalesStatics = () => {
  hqData.map((hq) => {
    return salesHeaders.map((imp) => {
      let priceData = {
        sales: `${Math.floor(Math.random() * 1000000000)}`,
        profitPrice: `${Math.floor(Math.random() * 1000000000)}`,
      };

      // 연 예상 매출 실적의 경우
      if (imp.val === 'sp') {
        priceData.salesRate = `${Math.floor(Math.random() * 100)}`;
        priceData.achiveRate = `${Math.floor(Math.random() * 100)}`;
      }

      hq[imp.val] = priceData;
    });
  });
  return Array.from(hqData);
};

export const makeTeamDataSalesStatic = () => {
  teamData.map((hq) => {
    return hq.children.map((team) => {
      return salesHeaders.map((imp) => {
        let priceData = {
          sales: `${Math.floor(Math.random() * 1000000000)}`,
          profitPrice: `${Math.floor(Math.random() * 1000000000)}`,
        };
        // 연 예상 매출 실적의 경우
        if (imp.val === 'sp') {
          priceData.achiveRate = `${Math.floor(Math.random() * 100)}`;
        }

        team[imp.val] = priceData;
      });
    });
  });
  return Array.from(teamData);
};

export const makeEmpDataSalesStatic = () => {
  teamEmpData.map((hq) => {
    return hq.children.map((team) => {
      return team?.children?.map((emp) => {
        return salesHeaders.map((imp) => {
          let priceData = {
            sales: `${Math.floor(Math.random() * 1000000000)}`,
            profitPrice: `${Math.floor(Math.random() * 1000000000)}`,
          };

          // 연 예상 매출 실적의 경우
          if (imp.val === 'sp') {
            priceData['achiveRate'] = `${Math.floor(Math.random() * 100)}`;
          }

          emp[imp.val] = priceData;
        });
      });
    });
  });
  return Array.from(teamEmpData);
};
